import { Button } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useCallback } from "react";
import { type IComment } from "src/pages/Summary/Summary.types";

import CommentsModal from "../../Summary/CommentsModal/CommentsModal";

interface Props {
  comments: IComment[] | undefined;
}

const ExportEntryComments = ({ comments }: Props) => {
  const [opened, { open, close }] = useDisclosure();

  const getButtonText = useCallback(() => {
    let text = "Comments";
    if (comments?.length) {
      text += `: ${comments.length}`;
    }
    return text;
  }, [comments?.length]);

  return (
    <>
      <Button variant="outline" onClick={open}>
        {getButtonText()}
      </Button>
      <CommentsModal
        opened={opened}
        onClose={close}
        comments={comments}
        type="readonly"
      />
    </>
  );
};

export default ExportEntryComments;
